var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDiscountBadge = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Frame"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M20.4987 5.13803C19.5519 3.65284 17.8919 2.66667 16 2.66667C14.1079 2.66667 12.4467 3.65251 11.5 5.13803C9.7808 4.75784 7.91035 5.23447 6.57292 6.57161C5.23536 7.90916 4.75765 9.78053 5.13803 11.5C3.65251 12.4467 2.66667 14.1079 2.66667 16C2.66667 17.8919 3.65284 19.5519 5.13803 20.4987C4.75703 22.2185 5.23497 24.0904 6.57292 25.4284C7.91037 26.7657 9.78072 27.2423 11.5 26.862C12.4467 28.3475 14.1079 29.3333 16 29.3333C17.8919 29.3333 19.5519 28.3472 20.4987 26.862C22.2183 27.2427 24.0893 26.766 25.4271 25.4284C26.7651 24.0904 27.2417 22.2187 26.8607 20.4987C28.3464 19.552 29.3333 17.8923 29.3333 16C29.3333 14.1075 28.3467 12.4467 26.8607 11.5C27.2412 9.78045 26.7647 7.90924 25.4271 6.57161C24.0893 5.23415 22.2183 4.75733 20.4987 5.13803Z",
  stroke: "#FDF8ED",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M12 20L20 12",
  stroke: "#FDF8ED",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M12.5 12.3333H12.3333M12.6667 12.3333C12.6667 12.5174 12.5174 12.6667 12.3333 12.6667C12.1492 12.6667 12 12.5174 12 12.3333C12 12.1492 12.1492 12 12.3333 12C12.5174 12 12.6667 12.1492 12.6667 12.3333Z",
  stroke: "#FDF8ED",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M19.8333 19.6667H19.6667M20 19.6667C20 19.8508 19.8508 20 19.6667 20C19.4825 20 19.3333 19.8508 19.3333 19.6667C19.3333 19.4825 19.4825 19.3333 19.6667 19.3333C19.8508 19.3333 20 19.4825 20 19.6667Z",
  stroke: "#FDF8ED",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDiscountBadge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-discount-badge.2343ebd659dc73a882c8f6ecf69aa33a.svg";